export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-light-sm-8c124b08c323d51eb5a5e1e7c810b1f1.png";